import Link from "./MoodLink";

const FavoriteCard = (props) => {
  const { image, title, url } = props;

  return (
    <Link to={url} target="_blank" className="group rounded-2xl block relative md:w-[270px] overflow-clip shrink-0 w-full">
      <div className="overflow-clip rounded-2xl">
        <img src={image} alt="favorites" className="group-hover:scale-[1.2] object-cover duration-700 overflow-clip aspect-square rounded-2xl w-full h-full" />
      </div>
      <div className="md:block hidden absolute rounded-2xl w-full h-full left-0 top-0" style={{ background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%)' }}></div>
      <div className="absolute w-fit h-fit md:block text-[32px] hidden left-0 right-0 top-0 bottom-0 m-auto text-white text-center font-bold">{title}</div>
      <div className="md:hidden text-sm text-center mt-1 block font-medium text-green-400">{title}</div>
    </Link>
    //    <div className="group md:block hidden relative md:w-[270px] rounded-2xl shrink-0 w-full overflow-clip">
    //         <div className="overflow-clip rounded-2xl">
    //           <img src={image} alt="favorites" className="group-hover:scale-[1.2] object-cover duration-700 overflow-clip aspect-square rounded-2xl w-full h-full" />
    //         </div>
    //         <div className="md:block hidden absolute rounded-2xl w-full h-full left-0 top-0" style={{ background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%)' }}></div>
    //         <div className="absolute w-fit h-fit md:block text-[32px] hidden left-0 right-0 top-0 bottom-0 m-auto text-white">{title}</div>
    //         <div className="md:hidden text-sm text-center mt-1 block font-medium text-green-400">{title}</div>
    //       </div> 
    //  <div className="group relative md:w-[270px] rounded-2xl shrink-0 w-full overflow-clip">
    //    <div className="overflow-clip rounded-2xl">
    //      <img src={image} alt="favorites" className="group-hover:scale-[1.2] object-cover duration-700 overflow-clip aspect-square rounded-2xl w-full h-full" />
    //    </div>
    //    <div className="md:block hidden absolute rounded-2xl w-full h-full left-0 top-0" style={{ background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%)' }}></div>
    //    <div className="absolute w-fit h-fit md:block text-[32px] hidden left-0 right-0 top-0 bottom-0 m-auto text-white">{title}</div>
    //    <div className="md:hidden text-sm text-center mt-1 block font-medium text-green-400">{title}</div>
    //  </div>

  )
};

export default FavoriteCard;